import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import Swal from "sweetalert2"
// Redux
import { connect } from "react-redux"
import { Redirect, withRouter } from "react-router-dom"

// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
//custom
import {
  CardBody,
  Card,
  Alert,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap"
import classnames from "classnames"
import SweetAlert from "react-bootstrap-sweetalert"

// actions
import { loginUser, apiError, socialLogin } from "../../store/actions"
import { color } from "echarts/lib/export"
import { isMobile } from "react-device-detect"
// import Alldata from "../../assets/localdata.json"

const Alldata = JSON.parse(localStorage.getItem("dataJ"))

const Login = props => {
  const [ms, setMS] = useState(false)

  const [ActiveTab, setActiveTab] = useState("Team")
  const [activeTabContent, setactiveTabContent] = useState("2")
  const [alert, setAlert] = useState(true)
  const [otherTeam, setOtherTeam] = useState("")
  const [handleChangeTeam, sethandleChangeTeam] = useState("")
  const [atrCommitteeTeam, setAtrCommitteeTeam] = useState("")
  const toggle1 = tab => {
    if (ActiveTab !== tab) {
      setActiveTab(tab)
    }
  }
  const [modal, toggleMS] = useState(false)
  const togms = () => {
    toggleMS(!modal)
  }

  // State to track the current slide index
  const [currentSlide, setCurrentSlide] = useState(0)
  const [formValues, setFormValues] = useState({
    Firstname: "",
    EmployerName: "",
    customaction: "Register",
    Lastname: "",
    Email: "",
    storeName: "",
    Designation: "",
    Teamname: "",
    LocationData: "",
    zipcode: "",
    tShirt: "",
    EventAttending: "",
    visaStatus: "",
    AccommodationRequirement: "",
    SpecialdietaryrequirementsAllergies: "",
    NotEngagePhysicalActivities: "",
    MedicalCondition: "",
    childrenAndcaretaker: "",
    requirementforchildrenAndcaretaker: "",
    suggestionConcern: "",
    particularInterestforRetreat: "",
    AttrCommitteeContribute: "",
    AtrCommitteeParticipate: "",
    ATRplanningcommittee: "",
    EmergencyContactName: "",
    EmergencyContactRelationship: "",
    EmergencyContactPhone: "",
    AlternateEmergencyContactPhone: "",
    bloodGroup: "",
    NotEventAttendingReason: "",
    acknowledgedment: "",
  })

  const handleChangeValue = e => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }

  function validateEmail(email) {
    var s,domainWhitelist = ["noorahealth.org", "nyuctech.com", "eblitzcreations.com"]
    for (s of domainWhitelist) if (email.endsWith(s)) return true

    return false
  }

  const handleSubmit = async values => {
    try {
    //  const res =  validateEmail(values?.Email)
     if(false) {
      Swal.fire({
        icon:"info",
        html: "Please enter a valid email address </br>{e.g., username@(noorahealth.org)}",
        confirmButtonColor: "#383838 ",
        confirmButtonText: "ok",
      }).then(result => {
        if (result.isConfirmed) {
          window.location.href = "/"
        }
      })
      return
     }

      const response = await fetch(process.env.REACT_APP_ADMIN + "/login", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      })
      const data = await response.json()

      if (data.Email) {
        localStorage.setItem("authUser", JSON.stringify(data))
      } else {
        Swal.fire({
          icon:
            data?.mssg === "Something went wrong, Please try again!"
              ? "error"
              : data?.mssg === "User Already registered <br></br> Stay Tuned"
              ? "success"
              : "success",
          text: data?.mssg,
          confirmButtonColor: "#383838 ",
          confirmButtonText: "ok",
        }).then(result => {
          if (result.isConfirmed) {
            window.location.href = "/login"
          }
        })
      }
    } catch (error) {
      console.error("Error submitting form:", error)
    }
  }
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    // props.loginUser(values, props.history)
    handleSubmit(values)
  }
  const hideAlert = () => {
    setAlert(false)
  }
  const loader = document.querySelector(".loader")

  useEffect(() => {
    setTimeout(() => {
      loader.classList.add("loader--hide")
    }, 1000)
  }, [])

  const handleChange = e => {
    let Team_Name = e.value
    // console.log("---", Team_Name)
    if (Team_Name === "Others") {
      setOtherTeam("Others")
    }
    if (Team_Name !== "Others") {
      setOtherTeam(null)
    }

    if (Team_Name === "Yes") {
      setOtherTeam("Yes")
    }
    if (Team_Name === "No") {
      setOtherTeam("No")
    }
  }

  const handleChangeTeamFunction = e => {
    let Team_Name = e.value
    // console.log("---", Team_Name)
    if (Team_Name === "Others") {
      sethandleChangeTeam("Others")
    }
    if (Team_Name !== "Others") {
      sethandleChangeTeam(null)
    }
  }

  const handleCommittee = e => {
    let Team_Name = e.value
    console.log("gg", Team_Name)
    setAtrCommitteeTeam(Team_Name)
  }

  const nextSlide = () => {
    if (otherTeam != "Yes") return handleSubmit(formValues)
    if (currentSlide == 4) return handleSubmit(formValues)
    setCurrentSlide(prevSlide => prevSlide + 1)
  }

  // Go to the previous slide
  const previousSlide = () => {
    setCurrentSlide(prevSlide => prevSlide - 1)
  }

  return Alldata.loginData.holdingSite ? (
    <React.Fragment>
      <MetaTags>
        <title>Bajaj Life</title>
      </MetaTags>
      {/* <img
        loading="lazy"
        src={
          isMobile ?
          "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/" +
          encodeURIComponent(Alldata.loginData.holdingImg) +
          "?alt=media"
          :
          "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/ABC%202025%2FLogin%20Phone.png?alt=media&token=05d6bb57-8e3a-4828-a567-5005c9115c43"
        }
        style={{ position: "absolute", width: "100%" }}
      ></img> */}

               
      <Modal
        size="xl"
        isOpen={ms}
        toggle={() => {
          setMS(!ms)
        }}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Photo Mosaic</h5>
          <button
            type="button"
            onClick={() => {
              setMS(!ms)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            allow="camera; microphone"
            title="test"
            className="embed-responsive-item mosaic"
            src={encodeURI("https://demo-mosaic.herokuapp.com/")}
          />
        </div>
      </Modal>
      <Container style={{ padding: 0, position: "relative" }} fluid>
        {/* <img
          loading="lazy"
          src={
            "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/" +
            encodeURIComponent(Alldata.loginData.holdingImg) +
            "?alt=media"
          }
          style={{ position: "absolute", width: "100%" }}
        ></img> */}
         <img
                  loading="lazy"
                  src={ 
                    isMobile
                      ? // LoginMobImage
                        "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/ABC%202026%2FHolding%20Screen%20(Phone).png?alt=media&token=625981ab-8345-41fc-9058-b8415d70f12a"
                      : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/ABC%202026%2FHolding%20Screen%20(Laptop).png?alt=media&token=8a0b0727-d55a-4c67-b268-3c74079c29d5"
                    // LoginLapImage
                  }
                  style={{ position: "absolute", width: "100%" }}
                  alt="Login"
                />
               
        <div className="account-pages pt-sm-2">
          <center>
            <Card
              className="overflow-hidden cardLogin"
              style={{
                display:"none",
                // boxShadow: "0px -5rem 2rem 0px rgb(18 38 63 / 3%)",
                boxShadow: "none",
              }}
            >
              <CardBody className="pt-0">
                <div className="p-2">
                  <h4
                    className="w-100 text-center"
                    style={{
                      color: "black",
                      marginBottom: "0px",
                      fontWeight: "bold",
                    }}
                  >
                    Sign up and let the fun begin!
                  </h4>
                  {/* <div style={{fontSize:"0.7rem",textAlign:"left",color:"black",fontWeight:"bold"}} className="mt-1" >I consent and authorize ABB to the use of my data as part of an ABB initiative to celebrate the Technology Day virtually. Please refer to the ABB privacy policy to know more - <a href="https://new.abb.com/privacy-notice/virtual-events">https://new.abb.com/privacy-notice/virtual-events</a></div> */}
                  <TabContent
                    activeTab={activeTabContent}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v)
                        }}
                      >
                        {props.error && typeof props.error === "string" ? (
                          props.error == "Invalid Email!" ||
                          props.error ==
                            "Somethiing went wrong, Please try again!" ||
                          props.error ==
                            "Oops! Your password is incorrect. Please try again using the correct password." ||
                          props.error ==
                            "User Already registered , Please come back again on the event day to log in." ||
                          props.error == "User not Found!" ||
                          props.error ==
                            "User not Found! Please Register to login" ||
                          props.error ==
                            "Registration successful. Click a picture with the Break the Bias pose right away at the Photo Mosaic Feature!" ? (
                            props.error ==
                            "Registration successful. Click a picture with the Break the Bias pose right away at the Photo Mosaic Feature!" ? (
                              <SweetAlert
                                show={alert}
                                success
                                title="Registered Successfully"
                                onConfirm={hideAlert}
                                // timeout={4000}
                              >
                                {props.error}
                              </SweetAlert>
                            ) : (
                              <SweetAlert
                                show={alert}
                                warning
                                // title="  Failed!"
                                onConfirm={hideAlert}
                                // timeout={4000}
                              >
                                {props.error}
                              </SweetAlert>
                            )
                          ) : (
                            <SweetAlert
                              show={alert}
                              success
                              title="Login Success!"
                              onConfirm={hideAlert}
                              // timeout={4000}
                            >
                              {props.error}
                            </SweetAlert>
                          )
                        ) : null}
                        {/* <div className="newlog">
                      Login
                    </div> */}
                        <div className="mb-2">
                          <AvField
                            name="Firstname"
                            value=""
                            className="form-control newgrad"
                            placeholder="First Name *"
                            type="text"
                            required
                            style={{}}
                          />
                        </div>
                        <div className="mb-2">
                          <AvField
                            name="Lastname"
                            value=""
                            className="form-control newgrad"
                            placeholder="Last Name *"
                            type="text"
                            required
                          />
                        </div>

                        <div className="mb-2">
                          <AvField
                            name="Email"
                            value=""
                            className="form-control newgrad"
                            placeholder="Email ID*"
                            type="email"
                            required
                          />
                        </div>
                        <div className="mb-2">
                          <AvField
                            name="customaction"
                            value="Login"
                            className="form-control newgrad"
                            placeholder="action *"
                            type="text"
                            required
                            disabled
                            hidden
                          />
                        </div>
                        {/* <div className="mb-2">
                          <AvField onChange={handleChangeValue}
                            name="Password"
                            value={formValues.Firstname}
                            className="form-control newgrad"
                            placeholder="Password *"
                            type="password"
                            required
                          />
                        </div> */}

                        <div
                          className="mt-3 d-flex justify-content-center"
                          style={{ textAlign: "center" }}
                        >
                          <button
                            style={{
                              backgroundColor: "#00A982",
                              color: "white",
                              borderColor: "white",
                              width: "33%",
                            }}
                            className="btn btn-primary btn-block"
                            type="submit"
                            disabled
                          >
                            Log In
                          </button>
                        </div>
                        {/* <div style={{ fontSize: "0.7rem", textAlign: "left", color: "black", fontWeight: "bold" }} className="mt-1">Kindly Register for before login. </div> */}
                      </AvForm>
                    </TabPane>

                    <TabPane tabId="2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e, v) => {
                          nextSlide(formValues)
                        }}
                      >
                        {props.error && typeof props.error === "string" ? (
                          [
                            "Invalid Email!",
                            "Somethiing went wrong, Please try again!",
                            "Oops! Your password is incorrect. Please try again using the correct password.",
                            "User Already registered , Please come back again on the event day to log in.",
                            // Your ID has been registered. Please come back again on the event day to log in.
                            "User not Found!",
                            "User not Found! Please Register to login",
                          ].includes(props.error) ? (
                            <SweetAlert
                              show={alert}
                              confirmButtonColor="green"
                              warning
                              onConfirm={() => {
                                // hideAlert();
                                // console.log("-------------------------")
                                window.location.href = "/login"
                              }}
                            >
                              {props.error}
                            </SweetAlert>
                          ) : props.error ===
                            "Registration successful. Click a picture with the Break the Bias pose right away at the Photo Mosaic Feature!" ? (
                            <SweetAlert
                              show={alert}
                              success
                              title="Registered Successfully"
                              onConfirm={() => {
                                // hideAlert();
                                // console.log("-------------------------")
                                window.location.href = "/login"
                              }}
                            >
                              {props.error}
                            </SweetAlert>
                          ) : props.error ===
                            "Your ID has been registered. <br></br> Stay Tuned" ? (
                            <SweetAlert
                              show={alert}
                              success
                              confirmButtonColor="red"
                              title="Registered Successfully"
                              onConfirm={() => {
                                // hideAlert();
                                // console.log("-------------------------")
                                window.location.href = "/login"
                              }}
                            >
                              {props.error}
                            </SweetAlert>
                          ) : (
                            <SweetAlert
                              show={alert}
                              success
                              title="Login Success!"
                              onConfirm={() => {
                                // hideAlert();
                                // console.log("-------------------------")
                                window.location.href = "/login"
                              }}
                            >
                              {props.error}
                            </SweetAlert>
                          )
                        ) : null}

                        {/* <div className="newlog">
                      Login
                    </div> */}
                        {currentSlide === 0 && (
                          <>
                            <div className="mb-2">
                              <p
                                className=" PlayfairDisplayBold text-start fw-bold mb-2"
                                style={{ marginBottom: "0" }}
                              >
                                Personal Details
                              </p>

                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Full Name as - per Govt. ID proof{" "}
                                <span className="text-danger">*</span>
                              </p>

                              <AvField
                                onChange={handleChangeValue}
                                name="Firstname"
                                value={formValues.Firstname}
                                className="form-control newgrad"
                                placeholder=""
                                type="text"
                                required
                              />
                            </div>
                            <div className="mb-2">
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Designation
                                <span className="text-danger">*</span>
                              </p>
                              <AvField
                                onChange={handleChangeValue}
                                name="Designation"
                                value={formValues.Designation}
                                className="form-control newgrad"
                                placeholder=""
                                type="text"
                                required
                              />
                            </div>

                            <div className="mb-2">
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Select Team Name + Country/Shared Team
                                <span className="text-danger">*</span>
                              </p>

                              <AvField
                                type="select"
                                name="Teamname"
                                className="form-control newgrad"
                                onChange={e => {
                                  handleChangeTeamFunction(e.target)
                                  handleChangeValue(e)
                                }}
                                value={formValues.Teamname}
                                required
                              >
                                <option hidden></option>
                                <option value="India Country Team">
                                  India Country Team
                                </option>
                                <option>Bangladesh Country Team</option>
                                <option>Indonesia Country Team</option>
                                <option>People & Culture, Shared Team</option>
                                <option>
                                  External Relations (Labs, Evaluation,
                                  Fundraising, Communications), Shared Team
                                </option>
                                <option>Shared Finance</option>
                                <option>Shared Programs</option>
                                <option>Country Expansion, Shared Team</option>
                                <option>Founders</option>
                                <option>Founder's Office</option>
                                <option>Others</option>
                              </AvField>
                            </div>

                            {handleChangeTeam === "Others" && (
                              <div className="mb-2">
                                <p
                                  className="text-start mb-0"
                                  style={{ marginBottom: "0" }}
                                >
                                  If others, Mention Team
                                  <span className="text-danger">*</span>
                                </p>
                                <AvField
                                  onChange={handleChangeValue}
                                  name="Teamname"
                                  className="form-control newgrad"
                                  placeholder=""
                                  value={formValues.Teamname}
                                  type="text"
                                  required
                                />
                              </div>
                            )}

                            <div className="mb-2">
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Email
                                <span className="text-danger">*</span>
                              </p>
                              <AvField
                                onChange={handleChangeValue}
                                name="Email"
                                value={formValues.Email}
                                className="form-control newgrad"
                                placeholder=""
                                type="email"
                                required
                              />
                            </div>
                            <div className="mb-2">
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Full Address (For shipment of any product)
                                <span className="text-danger">*</span>
                              </p>
                              <AvField
                                onChange={handleChangeValue}
                                name="LocationData"
                                value={formValues.LocationData}
                                className="form-control newgrad"
                                placeholder=""
                                type="text"
                                required
                              />
                            </div>
                            <div className="mb-2">
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                City, Zip Code/PIN Code
                                <span className="text-danger">*</span>
                              </p>
                              <AvField
                                onChange={handleChangeValue}
                                name="zipcode"
                                value={formValues.zipcode}
                                className="form-control newgrad"
                                placeholder=""
                                type="text"
                                required
                              />
                            </div>

                            <div className="mb-2">
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Select T-Shirt Size
                                <span className="text-danger">*</span>
                              </p>
                              <AvField
                                onChange={handleChangeValue}
                                className="form-control newgrad"
                                type="select"
                                name="tShirt"
                                required
                                value={formValues.tShirt}
                              >
                                <option hidden></option>
                                <option>XS</option>
                                <option>S </option>
                                <option>M </option>
                                <option>L </option>
                                <option>XL</option>
                                <option>XXL </option>
                                <option>XXXL</option>
                              </AvField>
                            </div>

                            <div className="mb-2">
                              <p
                                className="PlayfairDisplayBold text-start mb-2"
                                style={{ marginBottom: "0" }}
                              >
                                Participation & Accommodation
                              </p>
                              <p
                                className="text-start mb-0"
                                style={{ marginBottom: "0" }}
                              >
                                Will you be attending the 'Bajaj Life'?{" "}
                                <span className="text-danger">*</span>
                              </p>
                              <AvField
                                type="select"
                                name="EventAttending"
                                className="form-control newgrad"
                                value={formValues.EventAttending}
                                onChange={e => {
                                  handleChange(e.target)
                                  handleChangeValue(e)
                                }}
                                required
                              >
                                <option hidden>Yes/No</option>
                                <option>Yes</option>
                                <option>No</option>
                              </AvField>
                            </div>
                          </>
                        )}

                        {otherTeam === "Yes" && (
                          <>
                            {currentSlide === 1 && (
                              <>
                                <div className="mb-2">
                                  <p
                                    className="PlayfairDisplayBold text-start mb-2"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Required information
                                  </p>
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Select visa Status{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    type="select"
                                    name="visaStatus"
                                    className="form-control newgrad"
                                    value={formValues.visaStatus}
                                    required
                                  >
                                    <option hidden></option>
                                    <option>
                                      I have a valid visa and passport to travel
                                      to Bangalore, India.
                                    </option>
                                    <option>I need a visa</option>
                                    <option>I don't need a visa</option>
                                  </AvField>
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Do you have any special accommodation
                                    requirements? (e.g. wheelchair
                                    accessibility)
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="AccommodationRequirement"
                                    value={formValues.AccommodationRequirement}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Do you have any special dietary requirements
                                    or allergies?{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="SpecialdietaryrequirementsAllergies"
                                    value={
                                      formValues.SpecialdietaryrequirementsAllergies
                                    }
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                    required
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Are there any physical activities you cannot
                                    engage in? (considering there will be
                                    team-building exercises){" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="NotEngagePhysicalActivities"
                                    value={
                                      formValues.NotEngagePhysicalActivities
                                    }
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                    required
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Do you have any medical conditions or needs
                                    we should be aware of ?
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="MedicalCondition"
                                    value={formValues.MedicalCondition}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                              </>
                            )}
                            {currentSlide === 2 && (
                              <>
                                <div className="mb-2">
                                  <p
                                    className="PlayfairDisplayBold text-start mb-2"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Family Arrangements
                                  </p>
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    We value your full participation and
                                    engagement in this event. We understand that
                                    some attendees may have caregiving
                                    responsibilities that affect their ability
                                    to attend ATR (ie a breastfeeding parent).
                                    To support inclusivity, we are offering the
                                    option to bring a child under the age of 5,
                                    as long as you also have a caregiver present
                                    to supervise the child and enable you to
                                    stay involved. <br></br> <br></br>
                                    With this in mind, do you plan to bring a
                                    child under the age of 5 and caregiver to
                                    the event?
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="childrenAndcaretaker"
                                    value={formValues.childrenAndcaretaker}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                                <div
                                  className="mb-2"
                                  style={{ display: "none" }}
                                >
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Any special requirements or considerations
                                    for the children or caretakers?
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="requirementforchildrenAndcaretaker"
                                    value={
                                      formValues.requirementforchildrenAndcaretaker
                                    }
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                              </>
                            )}
                            {currentSlide === 3 && (
                              <>
                                <div className="mb-2">
                                  <p
                                    className="PlayfairDisplayBold text-start mb-2"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Additional Information
                                  </p>
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Do you have any suggestions or concerns for
                                    the retreat?
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="suggestionConcern"
                                    value={formValues.suggestionConcern}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Are there any specific activities or
                                    sessions you're particularly interested in
                                    or would like to see during the retreat?
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="particularInterestforRetreat"
                                    value={
                                      formValues.particularInterestforRetreat
                                    }
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Are you interested in joining the ATR
                                    Committee?{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    type="select"
                                    name="ATRplanningcommittee"
                                    className="form-control newgrad"
                                    value={formValues.ATRplanningcommittee}
                                    onChange={e => {
                                      handleCommittee(e.target)
                                      handleChangeValue(e)
                                    }}
                                    required
                                  >
                                    <option hidden></option>
                                    <option>Yes</option>
                                    <option>No</option>
                                  </AvField>
                                </div>
                                {atrCommitteeTeam === "Yes" && (
                                  <>
                                    <br></br>
                                    <div className="mb-2">
                                      <p
                                        className="text-start mb-0"
                                        style={{ marginBottom: "0" }}
                                      >
                                        Is there a specific area or subcommittee
                                        you would like to contribute to?{" "}
                                        <span className="text-danger">*</span>{" "}
                                        <br></br>
                                        (Please specify your preferred area and
                                        briefly explain why it interests you.{" "}
                                        <br></br>
                                        example: Overall planning committee,
                                        Session Planning & Facilitating, Support
                                        During the ATR Days, Others etc)
                                      </p>

                                      <AvField
                                        onChange={handleChangeValue}
                                        name="AttrCommitteeContribute"
                                        value={
                                          formValues.AttrCommitteeContribute
                                        }
                                        className="form-control newgrad"
                                        placeholder=""
                                        type="text"
                                        required
                                      />
                                    </div>
                                    <div className="mb-2">
                                      <p
                                        className="text-start mb-0"
                                        style={{ marginBottom: "0" }}
                                      >
                                        We understand that everyone has ongoing
                                        commitments, but participation in the
                                        ATR Committee will require dedicated
                                        time. How many hours per week can you
                                        realistically contribute?{" "}
                                        <span className="text-danger">*</span>{" "}
                                        <br></br>
                                      </p>

                                      <AvField
                                        onChange={handleChangeValue}
                                        name="AtrCommitteeParticipate"
                                        value={
                                          formValues.AtrCommitteeParticipate
                                        }
                                        className="form-control newgrad"
                                        placeholder=""
                                        type="text"
                                        required
                                      />
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                            {currentSlide === 4 && (
                              <>
                                <div className="mb-2">
                                  <p
                                    className="PlayfairDisplayBold text-start mb-2"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Emergency Information
                                  </p>
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Emergency Contact Name:{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="EmergencyContactName"
                                    value={formValues.EmergencyContactName}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                    required
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Emergency Contact Relationship:{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="EmergencyContactRelationship"
                                    value={
                                      formValues.EmergencyContactRelationship
                                    }
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                    required
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Emergency Contact Phone Number (with the
                                    country code):{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="EmergencyContactPhone"
                                    value={formValues.EmergencyContactPhone}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                    required
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Alternate Emergency Contact Number
                                    (optional)
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="AlternateEmergencyContactPhone"
                                    value={
                                      formValues.AlternateEmergencyContactPhone
                                    }
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start mb-0"
                                    style={{ marginBottom: "0" }}
                                  >
                                    Your Blood Group:{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    onChange={handleChangeValue}
                                    name="bloodGroup"
                                    value={formValues.bloodGroup}
                                    className="form-control newgrad"
                                    placeholder=""
                                    type="text"
                                    required
                                  />
                                </div>
                                <div className="mb-2">
                                  <p
                                    className="text-start"
                                    style={{ marginBottom: "1%" }}
                                  >
                                    Please acknowledge the following:{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvRadioGroup
                                    inline
                                    name="acknowledgedment"
                                    required
                                    // value="true"
                                  >
                                    <AvRadio
                                      style={{ backgroundColor: "transparent" }}
                                      label='I understand that the organization will take all necessary precautions to ensure safety and well-being during the retreat. However, I am responsible for my personal belongings and any personal decisions I make during the retreat."'
                                      value="true"
                                    />
                                  </AvRadioGroup>
                                </div>
                              </>
                            )}
                          </>
                        )}

                        {otherTeam === "No" && (
                          <div className="mb-2">
                            <p
                              className="text-start mb-0"
                              style={{ marginBottom: "0" }}
                            >
                              If you're unable to attend, please specify the
                              reason. <span className="text-danger">*</span>
                            </p>
                            <AvField
                              onChange={handleChangeValue}
                              name="NotEventAttendingReason"
                              className="form-control newgrad"
                              placeholder=""
                              type="text"
                              required
                            />
                          </div>
                        )}

                        <div className="mb-2">
                          <AvField
                            onChange={handleChangeValue}
                            name="customaction"
                            value="Register"
                            className="form-control newgrad"
                            placeholder="action *"
                            type="text"
                            required
                            disabled
                            hidden
                          />
                        </div>
                        {/* <div className="mb-2">
                          <AvField onChange={handleChangeValue}
                            name="Password"
                            value={formValues.Firstname}
                            className="form-control newgrad"
                            placeholder="Password *"
                            type="password"
                            required
                          />
                        </div> */}
                        <div
                          className="mt-3 d-flex justify-content-center align-items-center"
                          style={{ textAlign: "center" }}
                        >
                          {/* Show Next button only if attending is "Yes" */}
                          {otherTeam === "Yes" && currentSlide != 4 ? (
                            <>
                              {currentSlide > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-secondary mt-3 me-2"
                                  onClick={previousSlide}
                                >
                                  Back
                                </button>
                              )}
                              <button
                                type="sumbit"
                                className="btn btn-primary mt-3"
                              >
                                Next
                              </button>
                            </>
                          ) : (
                            <>
                              {currentSlide > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-secondary me-2"
                                  onClick={previousSlide}
                                >
                                  Back
                                </button>
                              )}
                              <button
                                style={{
                                  backgroundColor: "#383838",
                                  color: "white",
                                  borderColor: "white",
                                  width: "fit-content",
                                }}
                                className="btn btn-primary btn-block"
                                type="submit"
                              >
                                Register
                              </button>
                            </>
                          )}
                        </div>
                        {/* <div style={{ fontSize: "0.7rem", textAlign: "left", color: "black", fontWeight: "bold" }} className="mt-1">Kindly Register for before login. </div> */}
                      </AvForm>
                    </TabPane>
                  </TabContent>
                  {/* *Please use your official HPE ID to register */}
                </div>
              </CardBody>
            </Card>
          </center>
        </div>
      </Container>
    </React.Fragment>
  ) : (
    <Redirect to={{ pathname: "/login" }} />
  )
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
